import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApi,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type ReadBlocksV3 = OpalApi<'ReadBlocksV3', 200>

export const readCollection: ReadBlocksV3 = async ({
  params,
}: Parameters<ReadBlocksV3>[0] = {}) => {
  const url = new URL('/loupe/v3/blocks', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}

export const readSingle = async (
  params: OpalApiRequestParams<'ReadBlockV3'>
): Promise<OpalApiResponseDocument<'ReadBlockV3', 200>> => {
  const url = new URL(
    `/loupe/v3/blocks/${params.path.block_id}`,
    window.location.origin
  )

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
